'use client';
import { Swiper, SwiperSlide } from 'swiper/react';
import ArrowIcon from '../icons/arrow-icon';
import { useState } from 'react';
import { useTranslations } from 'next-intl';
import HeroCard from '../cards/hero-card';
import { Autoplay } from 'swiper/modules';
import useInViewPort from '@/hooks/useInViewPort';
import { event_view_promotion } from '@/utils/gtm';

const HeroSlider = ({ data = [], isMobile, locale }) => {
  const [swiper, setSwiper] = useState(null);
  const t = useTranslations('');
  const handleSlideChange = (swiper) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const slidesNo = swiper?.slides?.length;

  const fireViewPromotion = () => {
    if (data?.value?.length > 0) {
      const updatedData = data?.value?.map((item) => ({
        promotionImage: item?.[`img-${locale}`],
        key: data?.key,
        position: data?.position,
        id: item?.id,
        name: item?.[`alt-${locale}`],
      }));
      event_view_promotion(updatedData);
    }
  };
  const [ref] = useInViewPort(fireViewPromotion);

  return (
    <section className='relative'>
      {(isMobile ? slidesNo > 1 : slidesNo > 1)
        ? (locale === 'ar' ? !isEnd : !isBeginning) && (
            <button
              onClick={() =>
                locale === 'ar' ? swiper?.slideNext() : swiper?.slidePrev()
              }
              aria-label='Prev Button'
              className={`absolute cursor-pointer ${locale == 'en' ? 'start-10' : 'end-10'} bg-primary top-1/2 z-20 grid size-10 -translate-y-1/2 place-items-center rounded-md opacity-35 hover:opacity-100 max-md:hidden rtl:rotate-180`}
            >
              <ArrowIcon
                className={`text-white ${locale == 'en' ? 'rotate-90' : 'rotate-270'}`}
              />
            </button>
          )
        : null}
      <Swiper
        key={locale}
        dir={locale === 'en' ? 'ltr' : 'rtl'}
        onSwiper={setSwiper}
        onSlideChange={handleSlideChange}
        spaceBetween={80}
        loop={data?.value?.length > 3}
        onInit={(e) => e.slideTo(data?.value?.length / 2 - 1)}
        modules={[Autoplay]}
        autoplay={{ delay: 2500, pauseOnMouseEnter: true }}
        grabCursor
        centeredSlides
      >
        {data?.value?.map((info, i) =>
          (isMobile ? info?.['mobile-active'] : info?.active) ? (
            <SwiperSlide key={i} className='relative'>
              <HeroCard
                {...{
                  isMobile,
                  locale,
                  info,
                  t,
                  ref,
                  sliderKey: data?.key,
                  position: data?.position,
                }}
              />
            </SwiperSlide>
          ) : null
        )}
      </Swiper>
      {(isMobile ? slidesNo > 1 : slidesNo > 1)
        ? (locale === 'ar' ? !isBeginning : !isEnd) && (
            <button
              onClick={() =>
                locale === 'ar' ? swiper?.slidePrev() : swiper?.slideNext()
              }
              aria-label='Next Button'
              className={`absolute cursor-pointer ${locale == 'en' ? 'end-10' : 'start-10'} bg-primary top-1/2 z-20 grid size-10 -translate-y-1/2 place-items-center rounded-md opacity-35 hover:opacity-100 max-md:hidden rtl:rotate-180`}
            >
              <ArrowIcon
                className={`text-white ${locale == 'en' ? 'rotate-270' : 'rotate-90'}`}
              />
            </button>
          )
        : null}

      {/* Dots Navigation */}
      {/* <div className='absolute bottom-4 left-1/2 z-10 flex -translate-x-1/2 gap-2 max-sm:bottom-1'>
        {data?.value?.map((info, index) =>
          info?.active ? (
            <button
              key={index}
              onClick={() => swiper?.slideTo(index)}
              className={`h-3 w-3 rounded-full transition-all duration-300 max-[768px]:size-2 ${
                index === activeIndex
                  ? 'bg-primary w-6 max-[768px]:w-4'
                  : 'bg-primary/50 hover:bg-primary/75'
              }`}
            />
          ) : null
        )}
      </div> */}
    </section>
  );
};

export default HeroSlider;
